module.exports = __webpack_public_path__ + "img/content-mobile.83d843a3.png";